/**
 * GuestCounterRow.jsx
 * Created by michaelbray on 9/22/17.
 */

import React from 'react';
import PropTypes from 'prop-types';

import * as Icons from '../icons/Icons';

const propTypes = {
    guestType: PropTypes.shape({
        key: PropTypes.string,
        type: PropTypes.string,
        description: PropTypes.string
    }),
    count: PropTypes.number,
    maxTotalGuestsReached: PropTypes.bool,
    changeCount: PropTypes.func
};

const defaultProps = {
    guestType: {
        key: "",
        type: "",
        description: ""
    },
    count: 0,
    maxTotalGuestsReached: false
};

export default class GuestCounterRow extends React.Component {
    constructor(props) {
        super(props);

        this.increaseCount = this.increaseCount.bind(this);
        this.decreaseCount = this.decreaseCount.bind(this);
    }

    increaseCount() {
        this.props.changeCount(this.props.guestType.key, 1);
    }

    decreaseCount() {
        this.props.changeCount(this.props.guestType.key, -1);
    }

    render() {
        let disabledDecreaseCountClass = '';
        if (this.props.count === 0) {
            disabledDecreaseCountClass = 'disabled';
        }

        let disabledIncreaseCountClass = '';
        let disabledIncreaseCountOnClick = this.increaseCount;
        if (this.props.maxTotalGuestsReached) {
            disabledIncreaseCountClass = 'disabled';
            disabledIncreaseCountOnClick = null;
        }

        return (
            <li className="rec-guest-counter-row">
                <div className="rec-guest-counter-row-type">
                    <div className="rec-guest-counter-row-title">
                        {this.props.guestType.type}
                    </div>
                    <div className="rec-guest-counter-row-decription">
                        {this.props.guestType.description}
                    </div>
                </div>
                <div className="rec-increment-wrap">
                    <button
                        className={`guest-counter-row-icon ${disabledDecreaseCountClass}`}
                        onClick={this.decreaseCount}
                        type="button">
                        <span>
                            <Icons.IconRemoveCircleOutline alt={`${this.props.count} ${this.props.guestType.type}`} />
                        </span>
                    </button>
                    <div className="rec-guest-counter-row-quantity">
                        {this.props.count}
                    </div>
                    <button
                        className={`guest-counter-row-icon ${disabledIncreaseCountClass}`}
                        onClick={disabledIncreaseCountOnClick}
                        type="button">
                        <span>
                            <Icons.IconAddCircleOutline alt={`${this.props.count} ${this.props.guestType.type}`} />
                        </span>
                    </button>
                </div>
            </li>
        );
    }
}

GuestCounterRow.propTypes = propTypes;
GuestCounterRow.defaultProps = defaultProps;
